// extracted by mini-css-extract-plugin
export var timeline = "Timeline-module--timeline--3Hoju";
export var dots = "Timeline-module--dots--1nUPz";
export var dot = "Timeline-module--dot--32ATp";
export var point = "Timeline-module--point--JCDk9";
export var head = "Timeline-module--head--vylD1";
export var moveButtons = "Timeline-module--moveButtons--317Me";